/* eslint-disable no-underscore-dangle */

export default class Notification {
  constructor({
    id, icon, title, timeout, type, visible, dismissible, router, routerTitle,
  }) {
    this._id = id;
    this._visible = typeof visible === 'boolean' ? visible : false;
    this._title = title || null;
    this._icon = icon || null;
    this._timeout = timeout || null;
    this._type = type;
    this._dismissible = typeof dismissible === 'boolean' ? dismissible : false;
    this._router = router || null;
    this._routerTitle = routerTitle || null;
  }

  equals(obj) {
    if (obj instanceof Notification) {
      return obj.id === this.id;
    }
    return false;
  }

  get id() {
    return this._id;
  }

  // eslint-disable-next-line class-methods-use-this
  set id(id) {
    // unsupported operation
  }

  get dismissible() {
    return this._dismissible;
  }

  set dismissible(dismissible) {
    this._dismissible = typeof dismissible === 'boolean' ? dismissible : false;
  }

  get visible() {
    return this._visible;
  }

  set visible(visible) {
    this._visible = typeof visible === 'boolean' ? visible : false;
  }

  get title() {
    return this._title;
  }

  set title(title) {
    this._title = title;
  }

  get timeout() {
    return this._timeout;
  }

  set timeout(timeout) {
    this._timeout = timeout;
  }

  get type() {
    return this._type;
  }

  set type(type) {
    this._type = type;
  }

  get icon() {
    return this._icon;
  }

  set icon(icon) {
    this._icon = icon;
  }

  get router() {
    return this._router;
  }

  set router(router) {
    this._router = router;
  }

  get routerTitle() {
    return this._routerTitle;
  }

  set routerTitle(routerTitle) {
    this._routerTitle = routerTitle;
  }
}
